import { isSimulation } from 'src/core/classes/helpers/StorageHelper'
import { create as userCreate } from 'src/core/classes/models/User'
import { IAppState } from 'src/core/store/state'

export const appInitialState: IAppState = {
  authError: { result: false, message: '', code: '' },
  app: { id: '', ownerId: '' },
  user: userCreate(),
  queueProgress: 0,
  notifications: [],
  simulation: isSimulation(),
  simulationRoles: { allRoles: [], userRoles: [], mode: false },
  publishingMode: false,
}
